@use "~dso-toolkit/src/utilities";

:host {
  display: block;
}

@include utilities.box-sizing();
